// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({lblItem:"objekt",title:"Logga in",info:"Logga in för att komma åt objektet på {server} {resource}",oAuthInfo:"Logga in på {server}.",lblUser:"Användarnamn:",lblPwd:"Lösenord:",lblOk:"OK",lblSigning:"Loggar in...",lblCancel:"Avbryt",errorMsg:"Ogiltigt användarnamn/lösenord. Försök igen.",invalidUser:"Det användarnamn eller lösenord du har angett är felaktigt.",forbidden:"Användarnamnet och lösenordet är giltiga, men du har inte behörighet till den här resursen.",noAuthService:"Det gick inte att komma åt autentiseringstjänsten."});